import type { AsyncThunkApiConfig } from '@/store'

import { createAsyncThunk } from '@reduxjs/toolkit'
import { RejectError } from '../../typings'

/**
 * Refreshes GPS Data
 *
 * @private
 */
export const refreshGpsData = createAsyncThunk<
  // Return type of the payload creator
  void,
  // First argument to the payload creator
  uui.domain.actions.rpc.gps.FetchEntities,
  // thunk API
  AsyncThunkApiConfig<RejectError>
>('domain/gps/refreshData', async (entities, thunkApi) => {
  try {
    const rpc = thunkApi.extra.domainProxy.getRpc()

    const result = await rpc('rpc/gps/refreshData', {
      category: 'rpc',
      type: 'rpc/gps/refreshData',
      entities,
    })

    if (result.type === 'rpc-failure') {
      return thunkApi.rejectWithValue({
        type: 'rpcFailure',
        message: result.errorMessage,
        error: result,
      })
    }
  } catch (error) {
    thunkApi.extra.journal.main(
      `Unknown error on {refreshGpsData}`,
      { tags: ['rpc', 'order'], info: entities },
      'error',
    )

    return thunkApi.rejectWithValue({
      type: 'unknown',
      message: `Refresh GPS data Failed`,
      error,
    })
  }
})
